var _g, _g2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlaceTicketGreen = function SvgPlaceTicketGreen(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "random_icon",
    "data-name": "random icon",
    width: 26.365,
    height: 22.817,
    viewBox: "0 0 26.365 22.817",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_939",
    "data-name": "Rectangle 939",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 7.097, 3.311)",
    fill: "none",
    stroke: "#03a688",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.63,
    height: 18.63,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17.63,
    height: 17.63,
    rx: 1.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_940",
    "data-name": "Rectangle 940",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 4.822)",
    fill: "#fff",
    stroke: "#03a688",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.63,
    height: 18.63,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17.63,
    height: 17.63,
    rx: 1.5,
    fill: "none"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_162",
    "data-name": "Ellipse 162",
    cx: 1.774,
    cy: 1.774,
    r: 1.774,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 8.731, 18.555)",
    fill: "#03a688"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_170",
    "data-name": "Ellipse 170",
    cx: 1.774,
    cy: 1.774,
    r: 1.774,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 14.729, 16.948)",
    fill: "#03a688"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 1.774,
    cy: 1.774,
    r: 1.774,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 7.583, 14.27)",
    fill: "#03a688"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 1.774,
    cy: 1.774,
    r: 1.774,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 13.581, 12.663)",
    fill: "#03a688"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 1.774,
    cy: 1.774,
    r: 1.774,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 6.435, 9.986)",
    fill: "#03a688"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    cx: 1.774,
    cy: 1.774,
    r: 1.774,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 12.433, 8.378)",
    fill: "#03a688"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlaceTicketGreen, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyBpZD0icmFuZG9tX2ljb24iIGRhdGEtbmFtZT0icmFuZG9tIGljb24iIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjI2LjM2NSIgaGVpZ2h0PSIyMi44MTciIHZpZXdCb3g9IjAgMCAyNi4zNjUgMjIuODE3Ij4NCiAgPGcgaWQ9IlJlY3RhbmdsZV85MzkiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDkzOSIgdHJhbnNmb3JtPSJtYXRyaXgoMC45OTksIC0wLjAzNSwgMC4wMzUsIDAuOTk5LCA3LjA5NywgMy4zMTEpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwM2E2ODgiIHN0cm9rZS13aWR0aD0iMSI+DQogICAgPHJlY3Qgd2lkdGg9IjE4LjYzIiBoZWlnaHQ9IjE4LjYzIiByeD0iMiIgc3Ryb2tlPSJub25lIi8+DQogICAgPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxNy42MyIgaGVpZ2h0PSIxNy42MyIgcng9IjEuNSIgZmlsbD0ibm9uZSIvPg0KICA8L2c+DQogIDxnIGlkPSJSZWN0YW5nbGVfOTQwIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA5NDAiIHRyYW5zZm9ybT0ibWF0cml4KDAuOTY2LCAtMC4yNTksIDAuMjU5LCAwLjk2NiwgMCwgNC44MjIpIiBmaWxsPSIjZmZmIiBzdHJva2U9IiMwM2E2ODgiIHN0cm9rZS13aWR0aD0iMSI+DQogICAgPHJlY3Qgd2lkdGg9IjE4LjYzIiBoZWlnaHQ9IjE4LjYzIiByeD0iMiIgc3Ryb2tlPSJub25lIi8+DQogICAgPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxNy42MyIgaGVpZ2h0PSIxNy42MyIgcng9IjEuNSIgZmlsbD0ibm9uZSIvPg0KICA8L2c+DQogIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMTYyIiBkYXRhLW5hbWU9IkVsbGlwc2UgMTYyIiBjeD0iMS43NzQiIGN5PSIxLjc3NCIgcj0iMS43NzQiIHRyYW5zZm9ybT0ibWF0cml4KC0wLjI1OSwgLTAuOTY2LCAwLjk2NiwgLTAuMjU5LCA4LjczMSwgMTguNTU1KSIgZmlsbD0iIzAzYTY4OCIvPg0KICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzE3MCIgZGF0YS1uYW1lPSJFbGxpcHNlIDE3MCIgY3g9IjEuNzc0IiBjeT0iMS43NzQiIHI9IjEuNzc0IiB0cmFuc2Zvcm09Im1hdHJpeCgtMC4yNTksIC0wLjk2NiwgMC45NjYsIC0wLjI1OSwgMTQuNzI5LCAxNi45NDgpIiBmaWxsPSIjMDNhNjg4Ii8+DQogIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMTYzIiBkYXRhLW5hbWU9IkVsbGlwc2UgMTYzIiBjeD0iMS43NzQiIGN5PSIxLjc3NCIgcj0iMS43NzQiIHRyYW5zZm9ybT0ibWF0cml4KC0wLjI1OSwgLTAuOTY2LCAwLjk2NiwgLTAuMjU5LCA3LjU4MywgMTQuMjcpIiBmaWxsPSIjMDNhNjg4Ii8+DQogIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMTY5IiBkYXRhLW5hbWU9IkVsbGlwc2UgMTY5IiBjeD0iMS43NzQiIGN5PSIxLjc3NCIgcj0iMS43NzQiIHRyYW5zZm9ybT0ibWF0cml4KC0wLjI1OSwgLTAuOTY2LCAwLjk2NiwgLTAuMjU5LCAxMy41ODEsIDEyLjY2MykiIGZpbGw9IiMwM2E2ODgiLz4NCiAgPGNpcmNsZSBpZD0iRWxsaXBzZV8xNjQiIGRhdGEtbmFtZT0iRWxsaXBzZSAxNjQiIGN4PSIxLjc3NCIgY3k9IjEuNzc0IiByPSIxLjc3NCIgdHJhbnNmb3JtPSJtYXRyaXgoLTAuMjU5LCAtMC45NjYsIDAuOTY2LCAtMC4yNTksIDYuNDM1LCA5Ljk4NikiIGZpbGw9IiMwM2E2ODgiLz4NCiAgPGNpcmNsZSBpZD0iRWxsaXBzZV8xNjgiIGRhdGEtbmFtZT0iRWxsaXBzZSAxNjgiIGN4PSIxLjc3NCIgY3k9IjEuNzc0IiByPSIxLjc3NCIgdHJhbnNmb3JtPSJtYXRyaXgoLTAuMjU5LCAtMC45NjYsIDAuOTY2LCAtMC4yNTksIDEyLjQzMywgOC4zNzgpIiBmaWxsPSIjMDNhNjg4Ii8+DQo8L3N2Zz4NCg==";
export { ForwardRef as ReactComponent };